const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Przelewy2424 = function Przelewy2424(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement(
      "mask",
      {
        id: "przelewy24_24_svg__a",
        width: "48",
        height: "24",
        x: "0",
        y: "0",
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance",
        },
      },
      /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M48 0H0v24h48V0Z",
      })
    ),
    /*#__PURE__*/ React.createElement(
      "g",
      {
        mask: "url(#przelewy24_24_svg__a)",
      },
      /*#__PURE__*/ React.createElement("path", {
        fill: "#CE4749",
        d: "m0 18.28 1.216-6.852h3.136c.768 0 1.28.192 1.472.448.192.257.256.897.128 1.73-.128.768-.384 1.28-.704 1.6-.32.32-.896.385-1.728.385H1.216L.768 18.28H0Zm1.344-3.33H3.2c.768 0 1.28-.064 1.472-.256.192-.192.448-.512.512-1.089.128-.64.128-1.024.064-1.216-.064-.192-.448-.256-1.024-.256H1.856l-.512 2.817Zm5.312-1.473h.704l-.192.577h.064c.32-.449.832-.64 1.472-.64.896 0 1.259.448 1.088 1.344l-.064.32h-.704l.064-.128v-.256c.128-.448-.128-.704-.64-.704-.768 0-1.28.448-1.408 1.473l-.512 2.817h-.704l.832-4.803Zm3.712 0h3.456l-.128.705-3.456 3.522h2.88l-.128.576H9.28l.128-.64 3.52-3.522h-2.624l.064-.64Zm6.912 3.394h.704V17c-.064.513-.32.897-.64 1.089-.32.192-.896.256-1.664.256-.832 0-1.408-.128-1.6-.448-.192-.32-.256-1.025-.064-2.05.128-.96.384-1.6.768-1.92.384-.32.896-.513 1.664-.513.896 0 1.472.192 1.664.449.192.256.256.896.128 1.793l-.064.384H14.72c-.128.768-.128 1.216 0 1.409.128.192.448.32 1.024.32.597 0 .981-.043 1.152-.128.17-.086.299-.3.384-.64v-.129Zm.256-1.408v-.193c.128-.512.064-.832-.064-1.024-.128-.192-.512-.192-1.024-.192s-.96.064-1.152.256c-.192.192-.384.576-.512 1.152h2.752Zm2.944-4.035-1.216 6.852h-.704l1.216-6.852h.704Zm3.328 5.443h.704V17c-.064.513-.32.897-.64 1.089-.32.192-.896.256-1.664.256-.896 0-1.408-.128-1.6-.448-.192-.32-.256-1.025-.064-2.05.128-.96.384-1.6.768-1.92.384-.32.896-.513 1.664-.513.896 0 1.472.192 1.664.449.192.256.256.896.128 1.793l-.064.384h-3.456c-.128.768-.128 1.216 0 1.409.128.192.448.32 1.024.32.597 0 .981-.043 1.152-.128.17-.086.299-.3.384-.64v-.129Zm.256-1.408v-.193c.128-.512.064-.832-.064-1.024-.128-.192-.512-.192-1.024-.192s-.96.064-1.152.256c-.192.192-.384.576-.512 1.152h2.752Zm8-1.986-2.176 4.803h-1.024l-.192-2.625-.064-.833v-.832h-.064l-.128.448-.192.384-.32.833-1.088 2.625h-1.088l-.448-4.803h.704l.256 2.69.064.832v.833h.064l.128-.448.192-.385.32-.832 1.152-2.69h1.024l.192 2.69.064.832v.833h.064l.128-.448.192-.385.384-.832 1.152-2.69h.704Zm3.584 0-.96 2.178-.448 1.024-.192.577-.256.512-.128-.512-.064-.577-.192-1.024-.32-2.178h-.768l.96 5.251-.128.192c-.256.64-.64.96-1.024.96a1.6 1.6 0 0 1-.192-.063l-.128.576c.105.03.212.052.32.064.448 0 .832-.128 1.088-.384.256-.256.576-.768.896-1.473l2.24-5.123h-.704Z",
      }),
      /*#__PURE__*/ React.createElement("path", {
        fill: "#AFB2BA",
        d: "m40.832 17.704-.064.64h-4.864l.256-1.28c.128-.727.341-1.196.64-1.41.32-.256 1.024-.384 2.048-.512.853-.085 1.365-.213 1.536-.384.192-.192.384-.576.512-1.217.064-.576.064-.96-.128-1.152-.192-.192-.512-.256-1.152-.256-.832 0-1.344.064-1.6.192s-.384.512-.448 1.024l-.128.512h-.704l.064-.32c.128-.832.384-1.409.768-1.665s1.088-.384 2.112-.384c.896 0 1.472.128 1.728.448s.32.833.192 1.665c-.17.811-.427 1.366-.768 1.665-.341.3-.981.47-1.92.513-.896.128-1.408.256-1.6.384-.192.128-.384.576-.512 1.28v.257h4.032Zm6.336-6.148-.768 4.547h.96l-.128.64h-.96l-.256 1.601h-.768l.256-1.6h-3.712l.128-.897 4.096-4.29h1.152Zm-1.536 4.547.704-4.035-3.84 4.035h3.136Zm-29.76-6.724a24.698 24.698 0 0 1 4.672-2.113l-.32-1.665c-2.085.652-4.1 1.51-6.016 2.561l1.664 1.217Zm18.56-.897 5.76-3.201C37.824 4.576 34.752 4 30.976 4h-.064l-1.344 2.625c1.71.354 3.353.981 4.864 1.857Zm-21.696.513c-2.496 1.6-3.84 2.945-3.84 2.945h3.2l2.304-1.665-1.664-1.28Zm16.32-4.931a34.99 34.99 0 0 0-7.552 1.153l.256 1.729c2.432-.64 4.608-.769 6.528-.513l.768-2.369Zm14.208 2.497-7.488 2.754c.384.272.748.571 1.088.896H48s-1.28-1.985-4.736-3.65Z",
      })
    )
  );
};
Przelewy2424.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "24",
  fill: "none",
  viewBox: "0 0 48 24",
};
const sizeMap = {
  24: Przelewy2424,
};
export function Przelewy24(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Przelewy24' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
